import React, { useState, useEffect } from 'react';
import Cropper from '../crop';
import FilePicker from '../file_picker';
import { log, LOG_LEVELS } from '../../../common/config/app_logger';
import { useUploadUserAvatar } from '../../hooks/useUploadUserAvatar';

function UserAvatarPicker({
  children
}) {
  const [pickedFile, setPickedFile] = useState(null);
  const {
    uploadUserAvatar,
    loading,
    success,
    setSuccess
  } = useUploadUserAvatar();

  useEffect(() => {
    if (success) {
      setPickedFile(null);
      setSuccess(false);
    }
  }, [success, setSuccess]);

  const onModalCancel = () => {
    log(LOG_LEVELS.INFO, 'Picker', 'picker cancel');
    setPickedFile(null);
  };

  const filePicked = ({ file }) => {
    log(LOG_LEVELS.INFO, 'Picker', 'file picked');
    setPickedFile(URL.createObjectURL(file));
  };

  const onFileCropped = croppedFile => {
    log(LOG_LEVELS.INFO, 'Picker', 'file cropped');
    uploadUserAvatar(croppedFile);
    setPickedFile(null);
  };

  return (
    <>
      <FilePicker onFilePicked={ filePicked }>{children}</FilePicker>
      <Cropper
        file={ pickedFile }
        onCropFinished={ onFileCropped }
        onCancel={ onModalCancel }
        visible={ !!pickedFile }
        loading={ loading }
      />
    </>
  );
}

export default UserAvatarPicker;
